var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTooltipTailRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 8L7.99999 -3.02014e-07L0 1.03315e-06C3.33246 1.04666 7.02702 4.02537 8 8Z",
    fill: "#2C3558"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTooltipTailRight);
export default __webpack_public_path__ + "static/media/tooltip-tail-right.4f1193b74e9f53b9c6797ab9af4b72bb.svg";
export { ForwardRef as ReactComponent };